import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { Row, Col, Grid } from 'react-bootstrap';

import Link from '../Link';

import messages from '../../locale/jsonMessages';
import { withQuery } from '../../hoc/withGraphql';
import { dynamicBlogValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';

import getEnabledBlog from './getEnabledBlog.graphql';

import PlayStoreImage from '/public/siteImages/playStore.svg';
import AppStoreImage from '/public/siteImages/appStore.svg';
import facebookIcon from '/public/SiteIcons/facebookIcon.svg';
import twitterIcon from '/public/SiteIcons/twitterLogo.svg';
import instaIcon from '/public/SiteIcons/instagramIcon.svg';

import cs from '../../components/commonStyle.css';
import s from './Footer.css';

const Footer = ({ data: { getEnabledBlog }, whiteBg, isFooterToggle, intl }) => {

  const siteName = useSelector(state => state?.siteSettings?.data?.siteName);
  const facebook = useSelector(state => state?.siteSettings?.data?.facebookLink);
  const twitter = useSelector(state => state?.siteSettings?.data?.twitterLink);
  const instagram = useSelector(state => state?.siteSettings?.data?.instagramLink);
  const appAvailableStatus = useSelector(state => state?.siteSettings?.data?.appAvailableStatus);
  const playStoreUrl = useSelector(state => state?.siteSettings?.data?.playStoreUrl);
  const appStoreUrl = useSelector(state => state?.siteSettings?.data?.appStoreUrl);
  const isAuthenticated = useSelector(state => state?.runtime?.isAuthenticated);

  let becomeAHostLink = isAuthenticated ? '/become-a-owner?mode=new' : '/why-become-owner';

  const [rentall, setRentall] = useState(false);
  const [discover, setDiscover] = useState(false);
  const [hosting, setHosting] = useState(false);

  useEffect(() => {
    getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.map((item, key) => {
      if (item.footerCategory != 'discover' && item.footerCategory != 'hosting') {
        setRentall(true);
      }
      if (item.footerCategory == 'discover') {
        setDiscover(true);
      }
      if (item.footerCategory == 'hosting') {
        setHosting(true);
      }
    });
  }, [getEnabledBlog]);

  return (
    <div>
      <div className={cx(s.bgImageSection, "hidden-print", !isFooterToggle && s.footerContainer)}>
        <div className={cx(whiteBg ? s.bgWhite : s.bgColor)} />
        <Grid fluid className={s.container}>
          <Row>
            <Col sm={12} md={12} lg={12} xs={12}>
              <div className={s.displayGrid}>
                <div className={cs.spaceTop3}>
                  <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}>{siteName}</label>
                  <ul className={s.listContainer}>
                    <li>
                      <Link to={'/about'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                        <FormattedMessage {...messages.about} />
                      </Link>
                    </li>
                    <li>
                      <Link to={'/contact'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                        <FormattedMessage {...messages.contactForm} />
                      </Link>
                    </li>
                    {
                      rentall && getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.map((item, key) => {
                        if (item.footerCategory != 'discover' && item.footerCategory != 'hosting') {
                          const { pageTitle } = dynamicBlogValue(item, intl?.locale);
                          return (
                            <li key={key} >
                              <Link to={'/page/' + item.pageUrl} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                                {pageTitle}
                              </Link>
                            </li>
                          )
                        }
                      })
                    }
                  </ul>
                </div>
                <div className={cs.spaceTop3}>
                  <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}>
                    <FormattedMessage {...messages.discover} />
                  </label>
                  <ul className={s.listContainer}>
                    <li>
                      <Link to={'/safety'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                        <FormattedMessage {...messages.trustSafety} />
                      </Link>
                    </li>
                    {
                      discover && getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.map((item, key) => {
                        if (item.footerCategory == 'discover') {
                          const { pageTitle } = dynamicBlogValue(item, intl?.locale);
                          return (
                            <li key={key} >
                              <Link to={'/page/' + item.pageUrl} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                                {pageTitle}
                              </Link>
                            </li>
                          )
                        }
                      })
                    }
                  </ul>
                </div>
                <div className={cs.spaceTop3}>
                  <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}>
                    <FormattedMessage {...messages.hosting} />
                  </label>
                  <ul className={s.listContainer}>
                    <li>
                      <Link to={becomeAHostLink} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                        <FormattedMessage {...messages.becomeAHost} />
                      </Link>
                    </li>
                    <li>
                      <Link to={'/privacy'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                        <FormattedMessage {...messages.termsPrivacy} />
                      </Link>
                    </li>
                    <li>
                      <Link to={'/terms-of-service'} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                        <FormattedMessage {...messages.termsOfService} />
                      </Link>
                    </li>
                    {
                      hosting && getEnabledBlog && getEnabledBlog.length > 0 && getEnabledBlog.map((item, key) => {
                        if (item.footerCategory == 'hosting') {
                          const { pageTitle } = dynamicBlogValue(item, intl?.locale);
                          return (
                            <li key={key} >
                              <Link to={'/page/' + item.pageUrl} className={cx(cs.siteTextColor, cs.commonMediumText)} >
                                {pageTitle}
                              </Link>
                            </li>
                          )
                        }
                      })
                    }
                  </ul>
                </div>
                <div className={cs.spaceTop3}>
                  {(facebook || twitter || instagram) && <label className={cx(cs.commonMediumText, cs.paddingBottom2, cs.fontWeightBold)}><FormattedMessage {...messages.followUsText} /></label>}
                  <div className={s.socialFlex}>
                    {
                      facebook && <a href={facebook} target='_blank' className={s.shareIcon}>
                        <img src={facebookIcon} />
                      </a>
                    }
                    {
                      twitter && <a href={twitter} target='_blank' className={cx(s.shareIcon, s.twitterMargin)}>
                        <img src={twitterIcon} />
                      </a>
                    }
                    {
                      instagram && <a href={instagram} target='_blank' className={s.shareIcon}>
                        <img src={instaIcon} />
                      </a>
                    }
                  </div>
                </div>
              </div>
              <hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom6, cs.spaceTop6)} />
              <div className={cx(s.displayFlex, s.flexReverse)}>
                <h4 className={cx(cs.commonSmallText, cs.fontWeightNormal, s.siteNamePadding)}>© {siteName}</h4>
                {
                  appAvailableStatus == 1 && (playStoreUrl || appStoreUrl) &&
                  <div>
                    {
                      appStoreUrl && <a href={appStoreUrl} target='_blank' className={cx(cs.displayInlineBlock, s.appStoreMargin)}>
                        <img alt='Image' src={AppStoreImage} />
                      </a>
                    }
                    {
                      playStoreUrl && <a href={playStoreUrl} target='_blank' className={cs.displayInlineBlock} >
                        <img alt='Image' src={PlayStoreImage} />
                      </a>
                    }
                  </div>
                }
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    </div>
  );
}

Footer.propTypes = {
  siteName: PropTypes.string.isRequired,
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  instagram: PropTypes.string,
  appAvailableStatus: PropTypes.string,
  playStoreUrl: PropTypes.string,
  appStoreUrl: PropTypes.string,
  formatMessage: PropTypes.any,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getEnabledBlog: PropTypes.array,
  })
};

export default compose(
  injectIntl,
  withStyles(cs, s),
  withQuery(getEnabledBlog,
    {
      options: {
        fetchPolicy: 'network-only',
        ssr: false
      }
    }),
)(Footer);